<script>
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

export default {
  components: { TheHeader, TheFooter },
}
</script>

<template>
  <div>
    <TheHeader/>
    <slot/>
    <TheFooter v-if="$route.name !== 'login' && $route.name !== 'line login'"/>
  </div>
</template>


